import React from 'react';
import PrintTool from '../tools/component/PrintTool';
import MeasurementTool from '../tools/component/MeaurementTool';


const ToolsPanel: React.FC = () => {
  return (
    <aside id="sidebar">
      <section>
        <h3>Tools</h3>
        <h4 className="mobile-hidden">Measurement Tools</h4>
        <MeasurementTool />
        <h4>Print Map</h4>
        <PrintTool />
      </section>
    </aside>
  )
}

export default ToolsPanel